import { useQuery } from '@apollo/client'
import React, { FC, createContext } from 'react'
import { IWholesalePage } from '../components/types'
import { createWholeSalePage } from '../lib/createWholesalePage'
import { WHOLESALE } from '../queries/wholesaleQuery'
import { SortOrder } from '../__generated__/globalTypes'
import { wholesale, wholesaleVariables } from '../__generated__/wholesale'

interface IWholesale {
  page: IWholesalePage
}
export const WholesaleContext = createContext({} as IWholesale)

const WholesaleProvider: FC = ({ children }) => {
  const { data } = useQuery<wholesale, wholesaleVariables>(WHOLESALE, {
    variables: {
      where: {
        iblock: { code: { equals: 'wholesale-page' } },
        active: { equals: true },
      },
      first: 999,
      order: { sort: SortOrder.asc },
    },
  })

  const page = createWholeSalePage(data?.elements?.nodes)

  return (
    <WholesaleContext.Provider value={{ page }}>
      {children}
    </WholesaleContext.Provider>
  )
}
export default WholesaleProvider
